// components/Products.ts
import { computed, ref } from "vue";
import type { AnyThing } from "@/ProductTypes";


export const searchQuery = ref("");
export const selectedCategory = ref("");

export const products = ref<AnyThing[]>([]);

export const categories = computed(() => [
  ...new Set(products.value.map((p) => p.category)),
]);

export const filteredProducts = computed(() => {
  const tagStore = useTagStore()
  const selected = tagStore.selected

  // if no tags selected, show none
  if (selected.length === 0) {
    return []
  }

  return products.value.filter(product => {
    // must have a tags array
    if (!Array.isArray(product.tags)) {
      return false
    }
    // keep only if *every* selected tag is in product.tags
    return selected.every(tag => product.tags.includes(tag))
  })
})
